import { z } from 'zod';
import { apiEnvelope } from '../envelope';
import { memberIdSchema } from '../identity/legacy-identity-id';

// ─── escalation locator ─────────────────────────────────────────────────────
//
// Wire vocabulary for the staff read that resolves one escalation id to the
// member it belongs to. It exists so a link can name an escalation by an opaque
// id alone — the Slack card and the review queue open `/escalations/{id}` in
// Atlas — instead of a member URL that would carry "this member has an
// escalation" next to the member id wherever the URL is copied or logged.
//
// The pair is all it carries. Status, source, reason and handling stay behind
// the member page, whose access gate decides who sees them.

/** The path parameter. A request schema, so it is strict. */
export const escalationLocatorPathParamsSchema = z
  .object({
    escalationId: z.string().uuid(),
  })
  .strict();
export type EscalationLocatorPathParams = z.infer<typeof escalationLocatorPathParamsSchema>;

/**
 * The resolved pair. Not `.strict()`: Atlas parses responses with
 * `schema.parse()`, so a strict response would fail every bundle older than a
 * deploy that adds a field (ADR-135 Rule 1).
 */
export const escalationLocatorDataSchema = z.object({
  escalationId: z.string().uuid(),
  // The shared member-id grammar, not `.uuid()`: members imported from backend2
  // keep an id with no RFC version or variant guarantee.
  memberId: memberIdSchema,
});
export type EscalationLocatorData = z.infer<typeof escalationLocatorDataSchema>;

export const escalationLocatorResponseSchema = apiEnvelope(escalationLocatorDataSchema);
export type EscalationLocatorResponse = z.infer<typeof escalationLocatorResponseSchema>;
